module.exports = __webpack_public_path__ + "img/hest17.6216b640.jpg";